import { getActivePinia } from "pinia"

export const useKlokDictionaries = () => {
    const pinia = getActivePinia()
    const klok = useKlokStore(pinia)
    function getValue(attrName: string, key: number, locale: LanguageCode) {
        if (locale === "cs") {
            if (!klok.settings?.ciselniky[0]?.[attrName]) return key
            return klok.settings?.ciselniky[0]?.[attrName].find(
                item => item.key === key
            )?.value_cz
        }
        if (!klok.settings?.ciselniky[0]?.[attrName]) return key
        return klok.settings?.ciselniky[0]?.[attrName].find(
            item => item.key === key
        )?.value_en
    }
    function getDictionary(attrName: string) {
        return klok.settings?.ciselniky[0]?.[attrName]
    }
    return { getValue, getDictionary }
}
